import { useHistory } from 'react-router-dom';

import Event from './Event';
import NotFound from './NotFound';

const EventList = (props) => {
	const history = useHistory();

  return (
    <section className="event">
      {props.data.map((v) => (
        <Event key={v.e_seq} history={history} data={v} />
      ))}
			{props.data.length === 0 && <NotFound />}
    </section>
  );
};

export default EventList;
